import React, { useState } from "react";

import { Row, Col, Container } from "react-bootstrap";

import Logo from "../../common/images/logo.png";
import { PALETTE } from "../../common/ThemeConstants";
import SkillsRadar from "../../account/components/SkillsRadar";
import UserAvatar from "../../common/components/UserAvatar";
import { IoIosMale } from "react-icons/io";

export default function HomeProgresses() {
  const user = { id: 1, firstname: "Mario", lastname: "Rossi" }; // Example user data, replace with actual user data
  const [data, setData] = useState([
    { subject: "Panca Piana", A: 100, old: 80, active: true },
    { subject: "Stacco", A: 120, old: 85, active: true },
    { subject: "Military Press", A: 40, old: 50, active: true },
    { subject: "Chin-Up", A: 35, old: 20, active: false },
    { subject: "Squat", A: 120, old: 115, active: false },
  ])

  const getActiveData = () => {
    // Copy the data into a new array to avoid mutating the original data
    const activeData = data.map(item => ({ ...item }));

    // Set the value of A to 0 if the item is not active, otherwise keep the original value
    return activeData.map(item => ({
      ...item,
      A: item.active ? item.A : 0
    }));
  };

  const toggleActive = (index) => {
    const newData = [...data];
    newData[index].active = !newData[index].active;
    setData(newData);
  };

  return (
    <Container>
      <Container className="align-self-center text-center ms-auto me-auto">
        <h1 className="text-center">
          4. Monitora <span style={{ fontWeight: "bold" }}>i tuoi progressi</span>
        </h1>
        <p className="home-subtitle">
          Monitora i progressi dei tuoi massimali e i risultati ottenuti con il tuo piano di
          allenamento personalizzato
        </p>
      </Container>
      <br />
      <Row
        style={{
          maxWidth: "900px",
          border: "1px solid " + PALETTE.KINDALIGHTGRAY,
          backgroundColor: PALETTE.WHITE,
        }}
        className="m-auto rounded-md shadow-sm pb-4"
      >
        <Row className="w-100 m-auto align-items-center justify-content-between pb-4 pt-3">
          <Col className="text-start m-auto">
            <img src={Logo} alt="Logo" style={{ width: "70px" }} />
          </Col>
          <Col className="text-center">
            <p className="mb-0" style={{ fontWeight: "bold", color: PALETTE.DARK }}>
              Massimali
            </p>
          </Col>
          <Col className="text-end">
            <div
              style={{
                color: PALETTE.DARK,
                fontSize: "16px",
                background: PALETTE.GRADIENTLIGHT,
                width: "40px",
                height: "40px",
                display: "inline-flex"
              }}
              className="rounded-pill text-center align-items-center justify-content-center"
            >MR</div>
          </Col>
        </Row>
        <Row className="w-100 m-auto">
          <Col md={6} className="text-center">
            <div
              className="align-self-center text-center py-2 m-auto"
              style={{
                maxWidth: 500,
              }}
            >
              <SkillsRadar data={getActiveData()} user={user} radius={100} />
              <p className="mb-0">{user.firstname} {user.lastname}</p>
              <p className="mb-0" style={{ color: PALETTE.GRAY }}>
                <IoIosMale style={{ marginBottom: 4 }} /> Maschio, 29 anni
              </p>
            </div>
          </Col>
          <Col md={6} className="mb-4 align-self-center">
            <div
              className="align-self-center m-auto"
              style={{
                borderRadius: "10px",
                padding: "15px",
                maxWidth: 450,
              }}
            >
              {data.map((item, index) => (
                <div
                  key={index}
                  onClick={() => toggleActive(index)}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "10px 12px",
                    marginBottom: index === data.length - 1 ? "0px" : "10px",
                    borderRadius: "8px",
                    cursor: "pointer",
                    background: item.active ? PALETTE.GRADIENTLIGHT : PALETTE.WHITE,
                    border: !item.active ? `1px solid ${PALETTE.LIGHTGRAY}` : `1px solid ${PALETTE.MAINCOLORLIGHT}`,
                    transition: "all 0.2s ease",
                    // boxShadow: `0 2px 4px ${PALETTE.KINDAGRAY}`
                  }}
                  className="shadow-sm"
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div
                      style={{
                        width: "18px",
                        height: "18px",
                        borderRadius: "50%",
                        marginRight: "10px",
                        background: item.active ? PALETTE.WHITE : PALETTE.LIGHTGRAY,
                        // border: `2px solid ${item.active ? PALETTE.MAINCOLOR : PALETTE.KINDAGRAY}`,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                      }}
                    >
                      <div
                        style={{
                          width: "12px",
                          height: "12px",
                          borderRadius: "50%",
                          background: item.active ? PALETTE.GRADIENT : PALETTE.WHITE
                        }}
                      />
                    </div>
                    <p style={{ fontWeight: item.active ? "600" : "normal", marginBottom: 0 }}>
                      {item.subject}
                    </p>
                  </div>
                  <div>
                    {item.active && (
                      <>
                        <span
                          style={{
                            fontWeight: "bold",
                            color: item.active ? PALETTE.DARK : PALETTE.GRAY,
                            fontSize: "16px"
                          }}
                        >{item.A}</span>
                        <span style={{ fontSize: 12, paddingLeft: 4 }}>KG</span>
                      </>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Row>
    </Container>
  );
}
